import { render, staticRenderFns } from "./PageNavbarFederationDropdownItemList.vue?vue&type=template&id=5dd14d8f&scoped=true"
import script from "./PageNavbarFederationDropdownItemList.vue?vue&type=script&lang=ts"
export * from "./PageNavbarFederationDropdownItemList.vue?vue&type=script&lang=ts"
import style0 from "./PageNavbarFederationDropdownItemList.vue?vue&type=style&index=0&id=5dd14d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd14d8f",
  null
  
)

export default component.exports